var posturl={
    host : 'http://api.txcsok.com', //测试api
    //管理员登录
  login : '/Login/login',
  //管理员登录
  videoChangeAll : '/Video/videoChangeAll',
  //用户列表
  userList : '/User/userList',
  //用户状态更改
  userStateChange : '/User/userStateChange',
  Statistics : '/Statistics',
  vipCodeCount : '/User/vipCodeCount',
  changePwdOfSelf : '/User/changePwdOfSelf',
  listAdminUser : '/User/listAdminUser',
  removeAdminUser : '/User/removeAdminUser',
  addAdminUser : '/User/addAdminUser',
  editAdminUser : '/User/editAdminUser',
  changePwd : '/User/changePwd',

  // ----------商品管理--------
  //商品列表
  goodsList : '/Goods/goodsList',
//商品详情
  goodsinfo : '/Goods/goodsinfo',
//商品添加
  goodsadd : '/Goods/goodsadd',
//商品添加
  goodsedit : '/Goods/goodsedit',
//商品添加
  goodsStateChange : '/Goods/goodsStateChange',
  // ----------订单管理--------
//订单列表
  orderListE : '/Goodsorder/orderList',
//订单状态
  orderStateChange : '/Goodsorder/orderStateChange',
//订单删除
  orderDelete : '/Goodsorder/orderDelete',

  //文章列表
  articleList : '/Article/articleList',
  //发布文章
  articleadd : '/Article/articleadd',
  //编辑文章
  articleedit : '/Article/articleedit',
  //文章详情
  articleinfo : '/Article/articleinfo',
  //文章状态更改
  articleStateChange : '/Article/articleStateChange',


  //视频专题列表
  videoThemeList : '/Video/videoThemeList',
  //发布视频专题
  videoThemeadd : '/Video/videoThemeadd',
  //编辑视频专题
  videoThemeedit : '/Video/videoThemeedit',
  //视频专题状态变更
  videoThemeChange : '/Video/videoThemeChange',

  //视频列表
  videoList : '/Video/vedioList',
  //发布视频
  videoadd : '/Video/videoadd',
  //编辑视频
  videoedit : '/Video/videoedit',
  //视频状态变更
  videoChange : '/Video/videoChange',

  //音频专题列表
  audioThemeList : '/Audio/audioThemeList',
  //发布音频专题
  audioThemeadd : '/Audio/audioThemeadd',
  //编辑音频专题
  audioThemeedit : '/Audio/audioThemeedit',
  //音频专题状态变更
  audioThemeChange : '/Audio/audioThemeChange',

  //音频列表
  audioList : '/Audio/audioList',
  //发布音频
  audioadd : '/Audio/audioadd',
  //编辑音频
  audioedit : '/Audio/audioedit',
  //音频状态变更
  audioChange : '/Audio/audioChange',
  //头像管理列表
  imgList : '/Image/imgList',
  //新增头像
  imgAdd : '/Image/imgAdd',
  //编辑头像
  imgEdit : '/Image/imgEdit',
  //头像状态改变
  imgStateChange : '/Image/imgStateChange',
  //价格列表
  priceList : '/Price/priceList',
  //价格编辑
  priceEdit : '/Price/priceEdit',
  //大师列表
  masterList : '/Master/masterList',
  //大师新增
  addMaster : '/Master/addMaster',
  //大师编辑
  editMaster : '/Master/editMaster',
  //大师状态
  masterStateChange : '/Master/masterStateChange',
  //大师记录列表
  reservationList : '/Master/reservationList',
  //家居风水价格列表
  jjfsPrice : '/Price/jjfsPrice',
  //家居风水价格编辑
  jjfsPriceEdit : '/Price/jjfsPriceEdit',
  //罗盘价格列表
  lpPrice : '/Price/lpPrice',
  //罗盘价格编辑
  lpPriceEdit : '/Price/lpPriceEdit',
  //轮播图列表
  bannerList : '/Api/bannerList',
  //轮播图新增
  imgAddImg : '/Api/imgAdd',
  //轮播图编辑
  imgEditImg : '/Api/imgEdit',
  //轮播图状态变更
  imgStateChangeImg : '/Api/imgStateChange',
  //友情链接列表
  linksList : '/Api/linksList',
  //友情链接新增
  linksAdd : '/Api/linksAdd',
  //友情链接编辑
  linksEdit : '/Api/linksEdit',
  //友情链接状态变更
  linksStateChange : '/Api/linksStateChange',
  //网页订单列表
  orderListH5 : '/Order/orderListH5',
  //APP订单列表
  orderList : '/Order/orderList',
  //用户状态变更
  userwhitelistChange : '/User/userwhitelistChange',
  //管理员管理
  adminList : '/Admin/adminList.html',
  adminRegister : '/Admin/register.html',
  adminEdit : '/Admin/edit.html',
  userState : '/Admin/adminState.html',
  rPassWord : '/Admin/rPassWord.html',
  resetPassWord : '/Admin/resetPassWord.html',
  //大师接单状态变更
  masterjdStateChange : '/Master/masterjdStateChange',
  //帖子列表
  blogList : '/Blog/blogList',
  //帖子列表
  blogCommentsList : '/Blog/blogCommentsList',
  //帖子删除
  deletBlog : '//Blog/deletBlog',
  //头像定制订单详情
  orderInfo : '/Order/orderInfo',
  //提现列表
  withdrawRecord : '/Finance/withdrawRecord',
 //提现列表
  listTx : '/Admin/listTx',
  refuseTx : '/Admin/refuseTx',
  allowTx : '/Admin/allowTx',
  listTcLevel : '/Admin/listTcLevel',
  setTcLevel : '/Admin/setTcLevel',
  changeVideoOrder : '/Video/changeVideoOrder',
  changeVideoThemeOrder : '/Video/changeVideoThemeOrder',
  listMember : '/Admin/listMember',
  addMember : '/Admin/addMember',
  removeMember : '/Admin/removeMember',
  signRefund : '/Admin/signRefund',
  listShareholder : '/Admin/listShareholder',
  addShareholder : '/Admin/addShareholder',
  removeShareholder : '/Admin/removeShareholder',
  addBonus : '/Admin/addBonus',
  removeBonus : '/Admin/removeBonus',
  listBonus : '/Admin/listBonus',
  //订单
  listAppOrder : '/Admin/listAppOrder',
  //已处理
  ycl : '/Finance/qrhk',
//股东列表
  shareholderList : '/Shareholder/shareholderList',
  //用户列表
  userListGD : '/Shareholder/userList',
  //股东状态变更
  shareholderChange : '/Shareholder/shareholderChange',
  //分红记录
  dividendRecord : '/Shareholder/dividendRecord',
  //比例设置
  shareholderRateSet : '/Shareholder/shareholderRateSet',
  //比例获取
  shareholderRateGet : '/Shareholder/shareholderRateGet',
  //平台列表
  platList : '/Platform/platList',
  //新增平台
  addPlat : '/Platform/addPlat',
  //编辑平台
  editPlat : '/Platform/editPlat',
  //配置平台
  pzPlat : '/Platform/pzPlat',
  //用户状态变更
  platStateChange : '/Platform/platStateChange',
  //平台订单列表
  orderListPT : '/Platform/orderList',
  //查看上级
  superior : '/User/superior',
  //查看下级
  subordinate : '/User/subordinate',
  //改变上级
  changeSuperior : '/User/changeSuperior',
  //金额统计
  statistics : '/Finance/statistics',
  //提成比例设置
  recommendRateSet : '/Finance/recommendRateSet',
  //提成比例获取
  recommendRateGet : '/Finance/recommendRateGet',
  //新增支付广告
  adAd : '/Ad/adAd',
  //支付广告列表
  adList : '/Ad/adList',
  //编辑支付广告
  editAd : '/Ad/editAd',
  //状态改变支付广告
  adStateChange : '/Ad/adStateChange',
  //开关获取广告
  adPaySwitchGet : '/Ad/adPaySwitchGet',
  //开关设置广告
  adPaySwitchSet : '/Ad/adPaySwitchSet',
  //举报列表
  reportList : '/User/reportList',
  //档案列表
  dataList : '/User/dataList',
  //档案列表详情
  dataInfo : '/User/dataInfo',
  //拒绝提现
  refuse : '/Finance/refuse',
  //会员列表
  memberList : '/User/memberList',
  //开通会员
  makeVip : '/User/makeVip',
  //生成大师兑换码
  vipCode : '/User/vipCode',
  //消息推送
  send : '/Umeng/send',
  //团队列表
  teamList : '/Team/teamList',
  //队长列表
  leaderList : '/Team/leaderList',
  //用户搜索列表
  userListS : '/Team/userList',
  //新增队长
  addLeader : '/Team/addLeader',
  //编辑队长
  editLeader : '/Team/editLeader',
  //队长状态
  delLeader : '/Team/delLeader',
  //团队编辑
  editTeam : '/Team/editTeam',
  //团队删除
  delTeam : '/Team/delTeam',
  //提成记录
  recommendRecord : '/Team/recommendRecord',
}

global.posturl=posturl;



// WEBPACK FOOTER //
// ./src/system/url.js